import type { AutofillItem } from "./types";

export const statement: AutofillItem[] = [
  {
    keyword: "Director",
    contents: [
      "人と作品をつなぎ、想いを形にするための道筋を描きます。",
      "計画と創造の間に立ち、プロジェクトを円滑に進めます。",
      "理想を現実に変えるため、全ての歯車を確実に動かします。",
    ],
  },
  {
    keyword: "Music",
    contents: [
      "心に響く一瞬を切り取り、音で彩る旅を続けます。",
      "耳で聴くだけでなく、心で感じる音を創り続けます。",
      "限りない感情の波を音で描き、今ここだけの響きを届けます。",
      "聴く人それぞれの人生に寄り添い、音が織りなす景色を届けます。",
    ],
  },
  {
    keyword: "Sound effects",
    contents: [
      "音の一粒一粒に命を吹き込み、物語にリアルを宿します。",
      "音の中に潜む響きを掬い取り、皆さんを驚かせる音を創ります。",
      "音が語る真実を追求し、シーンの感動を最大限に引き出します。",
    ],
  },
  {
    keyword: "Voice",
    contents: [
      "声の力で心を動かし、キャラクターに息吹を与えます。",
      "耳に届くその声が、物語を超えた感情を伝えます。",
      "音に表情を宿し、聴く人の記憶に残る声を届けます。",
    ],
  },
  {
    keyword: "Post production",
    contents: [
      "音と映像の交差点で、作品の完成度を一段上へと引き上げます。",
      "ディテールにこだわり、音が紡ぐ空間を精緻に整えます。",
      "最後の一音までこだわり抜き、作品に命を吹き込みます。",
    ],
  },
  {
    keyword: "Planning",
    contents: [
      "言葉とアイデアで心を掴み、未来を形作るストーリーを生み出します。",
      "一言に魂を込め、想像を超える体験へと導きます。",
      "ゼロから世界を創り出し、人の心に響く企画を届けます。",
    ],
  },
  {
    keyword: "Design",
    contents: [
      "視覚に宿る力を信じ、作品やブランドの“顔”をデザインします。",
      "感性と理論の間で、瞬時に心を掴むビジュアルを生み出します。",
      "色と形に物語を込め、作品の存在価値を高めます。",
    ],
  },
  {
    keyword: "Movie",
    contents: [
      "一瞬一瞬の光を紡ぎ、物語を映像という形で届けます。",
      "映像の中に息づくリアルと美を追求し、観る人を引き込みます。",
      "視覚が語る物語で、心に焼き付く瞬間を創造します。",
    ],
  },
  {
    keyword: "Actor",
    contents: [
      "役を通して人生を演じ、人の心に残る存在となります。",
      "感情の奥底まで表現し、観る人にリアルな物語を届けます。",
      "演じることで世界を広げ、誰かの心の中に生き続ける存在を目指します。",
    ],
  },
];
